export default [
	{ id: 'ONE', question: 'SB-128 Reduces speed when nearing perimeter of aircraft or during inclement weather' },
	{ id: 'TWO', question: 'SB-156 Operator performs both a 50’ and 8’ test stop before approaching aircraft' },
	{ id: 'THREE', question: 'SB-27 Operator follows all designated traffic patterns' },
	{ id: 'FOUR', question: 'SB-29 Operator approaches the aircraft only at the direction of the ground guide' },
	{ id: 'FIVE', question: 'SB-121 Each time a ULD is placed onto a dolly, the dolly pins are verified secure by driver' },
	{ id: 'SIX', question: 'F-46 Employee maintains three points of contact while ascending / descending ladder.' }
]
